import { AiFillMail } from '@react-icons/all-files/ai/AiFillMail';
import { FaAddressCard } from '@react-icons/all-files/fa/FaAddressCard';
import { FaArchway } from '@react-icons/all-files/fa/FaArchway';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import { FaArrowDown } from '@react-icons/all-files/fa/FaArrowDown';
import { FaBox } from '@react-icons/all-files/fa/FaBox';
import { FaBoxes } from '@react-icons/all-files/fa/FaBoxes';
import { FaBuilding } from '@react-icons/all-files/fa/FaBuilding';
import { FaBullseye } from '@react-icons/all-files/fa/FaBullseye';
import { FaClock } from '@react-icons/all-files/fa/FaClock';
import { FaCommentDots } from '@react-icons/all-files/fa/FaCommentDots';
import { FaCopyright } from '@react-icons/all-files/fa/FaCopyright';
import { FaDollarSign } from '@react-icons/all-files/fa/FaDollarSign';
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope';
import { FaExclamationCircle } from '@react-icons/all-files/fa/FaExclamationCircle';
import { FaFacebook } from '@react-icons/all-files/fa/FaFacebook';
import { FaFacebookF } from '@react-icons/all-files/fa/FaFacebookF';
import { FaFileInvoiceDollar } from '@react-icons/all-files/fa/FaFileInvoiceDollar';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import { FaInfoCircle } from '@react-icons/all-files/fa/FaInfoCircle';
import { FaKey } from '@react-icons/all-files/fa/FaKey';
import { FaLinkedin } from '@react-icons/all-files/fa/FaLinkedin';
import { FaMailBulk } from '@react-icons/all-files/fa/FaMailBulk';
import { FaMapMarker } from '@react-icons/all-files/fa/FaMapMarker';
import { FaMapMarkerAlt } from '@react-icons/all-files/fa/FaMapMarkerAlt';
import { FaMinus } from '@react-icons/all-files/fa/FaMinus';
import { FaPhoneAlt } from '@react-icons/all-files/fa/FaPhoneAlt';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { FaPlusCircle } from '@react-icons/all-files/fa/FaPlusCircle';
import { FaRegBuilding } from '@react-icons/all-files/fa/FaRegBuilding';
import { FaRegCheckCircle } from '@react-icons/all-files/fa/FaRegCheckCircle';
import { FaRegEnvelope } from '@react-icons/all-files/fa/FaRegEnvelope';
import { FaRegStar } from '@react-icons/all-files/fa/FaRegStar';
import { FaRegTimesCircle } from '@react-icons/all-files/fa/FaRegTimesCircle';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import { FaStarHalfAlt } from '@react-icons/all-files/fa/FaStarHalfAlt';
import { FaStore } from '@react-icons/all-files/fa/FaStore';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaUserAlt } from '@react-icons/all-files/fa/FaUserAlt';
import { FaWpforms } from '@react-icons/all-files/fa/FaWpforms';
import { FaCheckCircle } from '@react-icons/all-files/fa/FaCheckCircle';
import { FaThermometerHalf } from '@react-icons/all-files/fa/FaThermometerHalf';
import { FaTruckMoving } from '@react-icons/all-files/fa/FaTruckMoving';
import { FaParking } from '@react-icons/all-files/fa/FaParking';
import { FaEye } from '@react-icons/all-files/fa/FaEye';
import { FaSignOutAlt } from '@react-icons/all-files/fa/FaSignOutAlt';
import { FaUserLock } from '@react-icons/all-files/fa/FaUserLock';
import { FaEyeSlash } from '@react-icons/all-files/fa/FaEyeSlash';
import { FaMoneyBillAlt } from '@react-icons/all-files/fa/FaMoneyBillAlt';
import { FaMoneyCheckAlt } from '@react-icons/all-files/fa/FaMoneyCheckAlt';
import { FaSyncAlt } from '@react-icons/all-files/fa/FaSyncAlt';
import { FaHeadset } from '@react-icons/all-files/fa/FaHeadset';
import { FaWrench } from '@react-icons/all-files/fa/FaWrench';
import { FaDoorClosed } from '@react-icons/all-files/fa/FaDoorClosed';
import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';
import { FaSync } from '@react-icons/all-files/fa/FaSync';
import { FaRegDotCircle } from '@react-icons/all-files/fa/FaRegDotCircle';
import { RiAlbumFill } from '@react-icons/all-files/ri/RiAlbumFill';
import { FaWindowClose } from '@react-icons/all-files/fa/FaWindowClose';
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight';
import { FaAngleLeft } from '@react-icons/all-files/fa/FaAngleLeft';
import { FaTimes } from '@react-icons/all-files/fa/FaTimes';
import { FaArrowUp } from '@react-icons/all-files/fa/FaArrowUp';
import { IoClose } from '@react-icons/all-files/io5/IoClose';

export default {
  FaAngleRight,
  FaArrowUp,
  FaAngleLeft,
  FaArrowLeft,
  FaArrowRight,
  FaArrowDown,
  FaPhoneAlt,
  FaArchway,
  FaBox,
  FaBoxes,
  FaRegCheckCircle,
  FaExclamationCircle,
  FaRegTimesCircle,
  FaPlusCircle,
  FaMapMarkerAlt,
  FaFileInvoiceDollar,
  FaDollarSign,
  FaMapMarker,
  FaRegBuilding,
  FaClock,
  FaBuilding,
  FaBullseye,
  FaCopyright,
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaMailBulk,
  FaAddressCard,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaMinus,
  FaPlus,
  FaCommentDots,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaInfoCircle,
  FaUserAlt,
  FaRegEnvelope,
  FaStore,
  FaWpforms,
  FaKey,
  AiFillMail,
  FaMoneyBillAlt,
  FaMoneyCheckAlt,
  FaSyncAlt,
  FaHeadset,
  FaWrench,
  FaDoorClosed,
  FaSignOutAlt,
  FaCheckCircle,
  FaEye,
  FaThermometerHalf,
  FaTruckMoving,
  FaParking,
  FaEyeSlash,
  FaExclamationTriangle,
  FaSync,
  FaUserLock,
  FaRegDotCircle,
  RiAlbumFill,
  FaWindowClose,
  FaTimes,
  IoClose,
};
